import { createApplicationContext } from '../applicationContext';
import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

export function runApp() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  renderApplication({ context, store });
}
